import { colors } from "@eisox/tokens";
import { tooltip as tooltipExtension } from "@tanstack/charts/tooltip";
import { portal } from "@tanstack/charts/tooltip/portal";

export const palette = Object.values(colors.chart);

export const axis = {
  line: false,
  ticks: { size: 0, padding: 12 },
  tickLabels: { fontSize: 12 },
} as const;

export const grid = { stroke: colors.primary.gray, strokeOpacity: 1 } as const;

export const tooltip = { use: tooltipExtension, portal, sticky: false } as const;
